import axios from "axios";
import React from "react";
import ComponentTitleSection from '../../library/baaShared/ComponentTitleSection';
import { TRIPADVISORURL, TRIPADVISORKEY } from "../../constants";
import "./Tripadvisor.scss";
import dictionary from 'i18next';
import glamorous from "glamorous";
import Slider from "react-slick";
import CustomNextArrow from "../../library/baaShared/CustomArrow/CustomNextArrow";
import CustomPrevArrow from "../../library/baaShared/CustomArrow/CustomPrevArrow";
import prevImage from "../../assets/icons-icon-arrow-left-beige@2x.png";
import nextImage from "../../assets/icons-icon-arrow-left@2x.png";
import LazyLoad from "react-lazy-load";


// const TRIPADVISORKEY = process.env.TRIPADVISORKEY;
// console.log()
class Tripadvisor extends React.Component {
  state = {
    reviewData: {},
  };

  componentDidMount() {
    const url =
      TRIPADVISORURL + this.props.fields.ID.value + `?key=${process.env.REACT_APP_TRIPADVISORKEY}`;
   
    axios({
      method: "POST",
      url: url,
      headers: {
        "Content-Type": "application/json",
      },
    }).then(response => {
      // console.log(response, "@@this is response")
      let reviewData = response.data;
      this.setState({ reviewData });
    });
  }

  viewReviews = () => {
    var id = this.props.fields.ID.value;
    var url = dictionary.t("TripAdvisorURL");
    var redirectUrl = url + id;
    window.open(redirectUrl);
  }

  render() {
    let { reviewData } = this.state;
    let title;
    // console.log(reviewData.rating, "check rating")
    let rank;
    let averageRating;

    let average_percentage;
    averageRating = reviewData.rating;
    // console.log("@@reviewData",reviewData)
    average_percentage = (averageRating * 100) / 5;
    if (this.props) {
      title = this.props && this.props.fields && this.props.fields.Title && this.props.fields.Title.value;
    }
    if (averageRating <= 1) {
      rank = `${dictionary.t("Tripadvisor-Rank-Terrible", "Terrible")}`;
    } else if (averageRating > 1 && averageRating <= 2) {
      rank = `${dictionary.t("Tripadvisor-Rank-Poor", "Poor")}`;
    } else if (averageRating > 2 && averageRating <= 3) {
      rank = `${dictionary.t("Tripadvisor-Rank-Average", "Average")}`;
    } else if (averageRating > 3 && averageRating <= 4) {
      rank = `${dictionary.t("Tripadvisor-Rank-Very-good", "Very Good")}`;
    } else if (averageRating > 4 && averageRating <= 5) {
      rank = `${dictionary.t("Tripadvisor-Rank-Excellent", "Excellent")}`;
    }

    const Box = glamorous.div({
      [":before"]: {
        content: ".",
        background: `url("${
          this.props.fields["Background Image"].value.src
          } no-repeat")`,
        backgroundAttachment: "scroll",

        backgroundSize: "cover",
        padding: ".5rem 1rem",
        // width: "100%",
        left: "0",
        right: "0",
        position: "absolute",
        height: "100%",
        top: "0",
        filter: "brightness(0.5)"
      }
    });

    const settings = {

      className: "center",
      centerMode: true,
      infinite: true,
      centerPadding: "0px",
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 3,
      initialSlide: 0,
      // dots: true,
      // dotsClass: "sliderDots",
      nextArrow: <CustomNextArrow img={nextImage} />,
      prevArrow: <CustomNextArrow img={nextImage} />,
      // autoplay: true,
      // autoplaySpeed: 5000,
      responsive: [
        // {
        //   breakpoint: 1024,
        //   settings: {
        //     infinite: true,
        //     // centerPadding: "50px",
        //     centerMode: true,
        //     slidesToShow: 3,
        //     slidesToScroll: 3,
        //     initialSlide: 3,
        //     arrows: false
  
        //   }
  
        // },
        // {
        //   breakpoint: 600,
        //   settings: {
        //     infinite: true,
        //     centerMode: true,
        //     // centerPadding: "50px",
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     initialSlide: 1,
        //     arrows: false
        //   }
        // },
        // {
        //   breakpoint: 480,
        //   settings: {
        //     centerPadding: "50px",
        //     centerMode: true,
        //     slidesToShow: 1,
        //     slidesToScroll: 1,
        //     initialSlide: 1,
        //     arrows: false
  
        //   }
        // }
      ]
    };
    return (
      <LazyLoad>
        <section
          className="full-bleed-component tripadvisor-module"
          id={this.props.rendering.componentName}
        >
          <ComponentTitleSection subtitle={title} />
          <div className="tripadvisor-wrapper">
            <Box />
            {/* <div
            className="tripadvisor-backgrund-image"
          >
            <img src={this.props.fields["Background Image"].value.src} />
          </div> */}
            <div className="linear-gradient-container"></div>
            <div className="row">
              <div className="tripadvisor-award-wrapper col-sm-12 col-md-12 col-lg-3">
                <div className="award">
                  <img
                    width="120px"
                    height="120px"
                    src={`${this.props.fields["Trip Advisor Logo"].value.src}`}
                    alt={`${this.props.fields["Trip Advisor Logo"].value.alt}`}
                    loading="lazy" 
                  />
                </div>
              </div>
              <div className="rating-wrapper col-sm-12 col-md-12 col-lg-3">
                <div className="rating">{averageRating}</div>

                <div className="rating-rank">
                  {this.props.fields["Avg Rating Label"] &&
                    this.props.fields["Avg Rating Label"].value}
                  <span>{rank}</span>

                </div>

                <div className="rating-picture">
                  <img
                    width="112px"
                    height="26px"
                    src={`${this.props.fields["Rating Empty"].value.src}`}
                    alt={`${this.props.fields["Rating Empty"].value.alt}`}
                    loading="lazy" 
                  />
                  <div
                    className="rating-star-filled-wrap"
                    style={{ width: (average_percentage + 3) + "%" }}
                  >
                    <img
                        width="112px"
                        height="26px"
                      src={`${this.props.fields["Rating Filled"].value.src}`}
                      alt={`${this.props.fields["Rating Filled"].value.alt}`}
                      loading="lazy" 
                    />
                  </div>
                </div>
              </div>

              <div className="user-review-wrapper col-sm-12 col-md-12 col-lg-6">
              <Slider {...settings}>
                {this.props.fields["Featured Review"].map((fields)=>{
                  return(
                    <div>
                    <div className="user-review">
                    <span>"</span>
                    {fields.fields["Review"].value}
                    <span>"</span>
                  </div>
                  <div className="username">
                    @{fields.fields["Author"].value}
                  </div>
                  </div>                
                  )
                })}              
              </Slider>
                </div>

                

              {/* <div className="user-review-wrapper col-sm-12 col-md-12 col-lg-6">
                <div className="user-review">
                  <span>"</span>
                  {this.props.fields["Featured Review"].value}
                  <span>"</span>
                </div>
                <div className="username">
                  {this.props.fields["Featured Review Author"].value}
                </div>
              </div> */}
                {/* <button
                className="view-reviews"
                onClick={this.viewReviews}
              >
                {dictionary.t("TripAdvisor-ViewReviews", "VIEW REVIEWS")}
              </button> */}

            </div>
            </div>
            <div onClick={()=>{window.open("https://www.tripadvisor.com/Attraction_Review-g295424-d23696659-Reviews-Inside_Burj_Al_Arab_Official-Dubai_Emirate_of_Dubai.html","_blank")}}
            className="trip_adviser_widget_main">

              {/* version 1  */}
            <div id="TA_cdsratingsonlynarrow894" class="TA_cdsratingsonlynarrow">
              <ul id="6RekqrqNMjS" class="TA_links ZZUHFXxT4eZ">
                <li id="ComiLh" class="NTVS2W7">
                  <a target="_blank" href="https://www.tripadvisor.com/Attraction_Review-g295424-d23696659-Reviews-Inside_Burj_Al_Arab_Official-Dubai_Emirate_of_Dubai.html">
                  <img width="115px" height="100px" src="https://www.tripadvisor.com/img/cdsi/img2/branding/v2/Tripadvisor_lockup_horizontal_secondary_registered-18034-2.svg" alt="TripAdvisor" loading="lazy" />
                  </a>
                </li>
              </ul>
            </div>

              {/* version 2 */}
            {/* <div id="TA_rated833" class="TA_rated">
            <ul id="mmqubPp0LS" class="TA_links SU1RBf3">
              <li id="UN5tCPMbQ5" class="Dd1eMw8t">
                  <a target="_blank" href="https://www.tripadvisor.com/Attraction_Review-g295424-d23696659-Reviews-Inside_Burj_Al_Arab_Official-Dubai_Emirate_of_Dubai.html">
                    <img width="115px" height="100px" src="https://www.tripadvisor.com/img/cdsi/img2/badges/ollie-11424-2.gif"  alt="TripAdvisor" />
                  </a>
                </li>
              </ul>
            </div> */}

            {/* version 3 */}
            {/* <div id="TA_linkingWidgetRedesign850" class="TA_linkingWidgetRedesign">
            <ul id="X6HLqKZWvq8w" class="TA_links 1oaoyMN">
              <li id="armnqhJ" class="0NxpTTxDidUK">
                  <a target="_blank" href="https://www.tripadvisor.com/Attraction_Review-g295424-d23696659-Reviews-Inside_Burj_Al_Arab_Official-Dubai_Emirate_of_Dubai.html">
                    <img width="115px" height="100px" src="https://static.tacdn.com/img2/brand_refresh/Tripadvisor_lockup_horizontal_secondary_registered.svg"  alt="TripAdvisor" />
                  </a>
                </li>
              </ul>
            </div> */}

            
          </div>
        </section>
      </LazyLoad>
    );
  }
}

export default Tripadvisor;